import {Component, OnInit, Input, ChangeDetectorRef, AfterViewChecked} from '@angular/core';
import {FormBuilder, Validators, FormGroup} from '@angular/forms';
import {Advance, AdvanceCloseActions, AdvanceTypes} from 'src/app/shared/models/advance.model';
import {map, shareReplay} from 'rxjs/operators';
import {AdvanceService} from 'src/app/shared/services/advance.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {Employee} from 'src/app/shared/models/employee.model';

export enum AdvanceClosingComment {
  transferAdvance = 'Kwota _advanceLeftValue_ zł została przeksięgowana na nową zaliczkę `_advanceName_`',
  returnFromEmployee = 'Pracownik zwrócił kwotę _advanceLeftValue_ zł',
  returnToEmployee = 'Pracownikowi zwrócono kwotę _advanceLeftValue_ zł',
}

export enum AdvanceOpeningComment {
  transferValueFromAdvance = '_advanceLeftValue_ zł - została przeksięgowana z zaliczki `_advanceName_`',
}

@Component({
  selector: 'app-modal-advance',
  templateUrl: './advance-modal.component.html'
})
export class ModalAdvanceComponent implements OnInit {
  @Input() isVisible: boolean = false;
  advanceFormGroup: FormGroup;
  advance: Advance;
  isNewAdvanceRequired$;
  renderer = false;
  advanceCloseAction;
  requestAdvance: any = {
    closingComment: '',
  };

  constructor(
    private fb: FormBuilder,
    private advanceService: AdvanceService,
    private toastrService: ToastrService,
    private router: Router,
    private detector: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.advanceCloseAction = AdvanceCloseActions;
    this.createFormGroup();
  }

  setupNewAdvanceNameRequired() {
    this.isNewAdvanceRequired$ = this.advanceFormGroup.get('action').valueChanges.pipe(
      map(value => {
        value === AdvanceCloseActions.TransferAdvance ?
          this.advanceFormGroup.get('newAdvanceName').setValidators([Validators.required]) :
          this.advanceFormGroup.get('newAdvanceName').setValidators([]);
        return value === AdvanceCloseActions.TransferAdvance;
      }),
      shareReplay()
    );
  }

  createFormGroup() {
    this.advanceFormGroup = this.fb.group({
      action: [AdvanceCloseActions.CloseAdvance, [Validators.required]],
      newAdvanceName: [],
    });
  }

  submit() {
    const action = this.advanceFormGroup.get('action').value;
    // TODO: Find better way to add closing comment to advance
    if (Object.keys(AdvanceClosingComment).includes(action)) {
      this.requestAdvance.closingComment = AdvanceClosingComment[action]
        .replace('_advanceLeftValue_', Math.abs(this.advance.leftValue).toString())
        .replace('_advanceName_', this.advanceFormGroup.get('newAdvanceName').value);
    }
    switch (action) {
      case AdvanceCloseActions.TransferAdvance:
        this.requestAdvance = {
          ...this.requestAdvance,
          name: this.advanceFormGroup.get('newAdvanceName').value,
          value: this.advance.leftValue,
          employee: (this.advance.employee as Employee).id,
          openingComment: AdvanceOpeningComment.transferValueFromAdvance
            .replace('_advanceLeftValue_', Math.abs(this.advance.leftValue).toString())
            .replace('_advanceName_', this.advance.name),
          type: AdvanceTypes.Additional
        };
        break;
    }
    this.advanceService.closeAdvance(this.requestAdvance, this.advance.id, this.advanceFormGroup.get('action').value)
      .subscribe(_ => {
        this.toastrService.success('Zaliczka została poprawnie zamknięta.');
        this.redirectTo('/advances/employees/active');
        this.close();
      }, _ => this.toastrService.error('Zaliczka nie została zamknięta.'));
  }

  open(advance: Advance) {
    this.advance = advance;
    this.setupNewAdvanceNameRequired();
    if (advance.leftValue < 0) {
      this.advanceFormGroup.patchValue({
        action: AdvanceCloseActions.ReturnToEmployee
      });
    } else if (advance.leftValue > 0) {
      this.advanceFormGroup.patchValue({
        action: null,
        newAdvanceName: []
      });
    }
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
  }

  // TODO: Change redirect to response!
  redirectTo(uri: string) {
    this.router.navigateByUrl('/advances', {skipLocationChange: true}).then(() =>
      this.router.navigate([uri]));
  }
}
